import {clx} from '@hm/fundamental'
import {useState} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

import {KilnShutdownActions} from './KilnShutdownActions'
import {KilnShutdownInputs} from './KilnShutdownInputs'

import {ShutdownStatus} from '@refra/modules/common/enums'
import type {ShutdownForm, NewShutdown} from '@refra/modules/common/types'
import type {KilnShutdown} from '@refra/modules/refra-planning/types'

interface KilnShutdownFormProps {
  kilnShutdown: KilnShutdown | NewShutdown
  isRowLayout?: boolean
}

export const KilnShutdownForm: React.FC<KilnShutdownFormProps> = ({
  kilnShutdown,
  isRowLayout = true
}) => {
  const {id, shutdownType, name, interventionDate, feedingDate} = kilnShutdown

  const isNewShutdown = id === undefined
  const isDraftShutdown = kilnShutdown.shutdownStatus === ShutdownStatus.Draft

  const [isEditMode, setIsEditMode] = useState(false)

  const kilnShutdownForm = useForm<ShutdownForm>({
    shouldFocusError: false,
    defaultValues: {id, shutdownType, name, interventionDate, feedingDate}
  })

  return (
    <FormProvider {...kilnShutdownForm}>
      <div
        className={clx(
          'flex justify-between gap-6',
          isRowLayout ? 'items-center' : 'items-start',
          isRowLayout ? 'flex-row' : 'flex-col'
        )}
      >
        <KilnShutdownInputs isReadOnly={!(isNewShutdown || isEditMode)} isRowLayout={isRowLayout} />
        <KilnShutdownActions
          isNewShutdown={isNewShutdown}
          isDraftShutdown={isDraftShutdown}
          isEditMode={isEditMode}
          setIsEditMode={setIsEditMode}
          isRowLayout={isRowLayout}
          kilnShutdown={kilnShutdown}
        />
      </div>
    </FormProvider>
  )
}
